import React, {ReactElement} from 'react';
import {InputAdornment, InputProps, TextField, TextFieldProps} from '@mui/material';

const PWMTextInput: React.FC<IPWMTextInputProps> = (props) => {
  const {helpText,startAdornment,endAdornment, ...rest} = props;
  const otherInputProps: InputProps = {};
  if(startAdornment){
    otherInputProps.startAdornment = <InputAdornment position="start">{startAdornment}</InputAdornment>;
  }
  if(endAdornment){
    otherInputProps.endAdornment = <InputAdornment position="end">{endAdornment}</InputAdornment>;
  }
  if (props.type == 'date') {
    // @ts-ignore
    rest.InputLabelProps = rest.InputLabelProps || {};
    // @ts-ignore
    rest.InputLabelProps.shrink = true;
  }
  if(Object.keys(otherInputProps).length > 0) {
    // @ts-ignore
    rest.InputProps = otherInputProps;
  }
  return (
    <TextField
      name={props.id}
      autoComplete="off"
      helperText={helpText}
      {...rest}
    />
  );
};

export default PWMTextInput;

interface IPWMTextInputProps extends Pick<TextFieldProps, 'spellCheck' | 'autoCapitalize' | 'autoCorrect' | 'autoFocus' | 'type' | 'required' | 'multiline' | 'rows' | 'maxRows' | 'minRows' | 'disabled' | 'onKeyDown'> {
  children?: React.ReactNode;
  id: string;
  label?: string;

  onChange?(e: any): any;
  disabled?: boolean;
  helpText?: string;
  placeholder?: string;
  fullWidth?: boolean;
  value?: string | number;
  endAdornment?: string | ReactElement;
  startAdornment?: string | ReactElement;
  defaultValue?: string | number;
}